import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizationPipelineLogEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.table_name = null;
		/** @type {string} */
		this.description = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _OptimizationPipelineLogEditDtoProps
	 * @property {string} table_name
	 * @property {string} description
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationPipelineLogEditDtoProps} OptimizationPipelineLogEditDtoProps
	 */
	/**
	 *
	 * @param {OptimizationPipelineLogEditDtoProps} props
	 * @returns {OptimizationPipelineLogEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.table_name = props.table_name;
		this.description = props.description;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default OptimizationPipelineLogEditDto;